// extracted by mini-css-extract-plugin
export var copyableField = "_op-4";
export var customerBadge = "_op-0";
export var customerInfoTitle = "_op-2";
export var details = "_op-1";
export var dropdownContainer = "_op-5";
export var dropdownImage = "_op-6";
export var editAssigneeForm = "_op-a";
export var editButton = "_op-3";
export var email = "_op-7";
export var hidden = "_op-d";
export var input = "_op-8";
export var saveButton = "_op-b";
export var shopifyIcon = "_op-c";
export var suggestionBadge = "_op-e";
export var suggestionText = "_op-f";
export var username = "_op-9";